import axios from "axios";

export const reviewsData = () => {
  return axios
    .get("/rates")
    .then((response) => {
    //   console.log(response.data);
      return response;
    });
};